import React, { useEffect, useState } from 'react';
import { announcementAPI } from '../services/api';
import { Announcement } from '../types';
import './Announcements.css';

const Announcements: React.FC = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState<Announcement | null>(null);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await announcementAPI.getAll();
      setAnnouncements(response.data.announcements);
    } catch (error) {
      console.error('Duyuru yükleme hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const getExcerpt = (content: string, maxLength: number = 150) => {
    if (content.length <= maxLength) return content;
    return content.substring(0, maxLength).trim() + '...';
  };

  return (
    <>
      {/* Hero Section */}
      <section className="screen screen-blog">
        <div className="panel-content">
          <h1 className="announcements-hero-title">Duyurular ve Güncel Makaleler</h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="screen-tail screen-tail--blog" aria-label="Duyurular içerik alanı">
        <div className="tail-container">
          {/* Loading State */}
          {loading ? (
            <div className="announcements-loading">
              <div className="spinner">
                <i className="bi bi-arrow-repeat"></i>
              </div>
              <p>Duyurular yükleniyor...</p>
            </div>
          ) : announcements.length === 0 ? (
            <div className="announcements-empty">
              <i className="bi bi-inbox"></i>
              <h3>Duyuru Bulunamadı</h3>
              <p>Henüz duyuru bulunmamaktadır.</p>
            </div>
          ) : (
            <div className="announcements-grid">
              {announcements.map((announcement) => (
                <article key={announcement.id} className="announcement-card">
                  {/* Card Content */}
                  <div className="announcement-body">
                    <h3 className="announcement-title">
                      {announcement.title}
                    </h3>

                    <div className="announcement-meta">
                      <span className="announcement-date">
                        <i className="bi bi-calendar3"></i>
                        {formatDate(announcement.created_at)}
                      </span>
                    </div>

                    <p className="announcement-excerpt">
                      {getExcerpt(announcement.content)}
                    </p>

                    <button
                      onClick={() => setSelectedAnnouncement(announcement)}
                      className="announcement-read-more"
                    >
                      Devamını Oku
                      <i className="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Modal */}
      {selectedAnnouncement && (
        <div className="announcement-modal-overlay" onClick={() => setSelectedAnnouncement(null)}>
          <div className="announcement-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-header-content">
                <h2 className="modal-title">{selectedAnnouncement.title}</h2>
                <div className="modal-meta">
                  <i className="bi bi-calendar3"></i>
                  <span>{formatDate(selectedAnnouncement.created_at)}</span>
                </div>
              </div>
            </div>
            <div className="modal-content" dangerouslySetInnerHTML={{ __html: selectedAnnouncement.content }} />
            <a href="mailto:info@avsk.com" className="modal-action-button">
              Daha Fazla Bilgi ve İletişim
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Announcements;
